export enum WarehouseProductType {
  Accessories = 'ACCESSORIES',
  Box = 'BOX',
  Cosmetic = 'COSMETIC',
  Product = 'PRODUCT',
}
